import { Info } from "lucide-react"

type Props = {
  message: string
}

export function DisabledSubTabMessage({ message }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <Info className="size-8 text-muted-foreground" />
      <p className="text-sm text-muted-foreground max-w-md">{message}</p>
    </div>
  )
}
